import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import ReplyComment from './reply-comment';
import { CommentsProps } from '../../comments/comments.props';

const ReplyComments = ({ list }: any) => {
  if (list && list?.length) {
    return (
      <Div className={'flex-col gap-4'}>
        {list?.map((replyItem: CommentsProps) => (
          <ReplyComment
            key={replyItem?.id}
            id={replyItem?.id}
            user_name={replyItem?.user_name}
            content={replyItem?.content}
            created_at={replyItem?.created_at}
          />
        ))}
      </Div>
    );
  }

  return null;
};

export default ReplyComments;
